import { ORDERS_YEAR_STORAGE_KEY } from '../stores/orders-year.atom';

export const getOrdersYear = () => {
  const year = localStorage.getItem(ORDERS_YEAR_STORAGE_KEY);

  try {
    return JSON.parse(year as string);
  } catch {
    return year;
  }
};

export default getOrdersYear;
